export const TaskUpdateTypes = {
    Created: 'CREATED',
    Closed: 'CLOSED',
    Reviewed: 'REVIEWED',
    Reopened: 'REOPENED',
    Assignment: 'ASSIGNMENT',
    Reassignment: 'REASSIGNMENT',
    Unassignment: 'UNASSIGNMENT',
    StatusChange: 'STATUS_CHANGE',
    SeverityChange: 'SEVERITY_CHANGE',
    SeverityUpgrade: 'SEVERITY_UPGRADE',
    DeviceAlertTriggered: 'DEVICE_ALERT_TRIGGERED',
    DeviceAlertReset: 'DEVICE_ALERT_CANCELED',
    DeviceInteraction: 'DEVICE_INTERACTION',
    DeviceInteractionDoorOpen: 'DEVICE_INTERACTION_DOOR_OPEN',
    DeviceInteractionDoorClosed: 'DEVICE_INTERACTION_DOOR_CLOSED',
    DeviceInteractionDoorAccessGranted: 'DEVICE_INTERACTION_DOOR_ACCESS_GRANTED',
    DeviceInteractionDoorUnauthorizedExit: 'DEVICE_INTERACTION_DOOR_UNAUTHORIZED_EXIT',
    DeviceInteractionFallDetected: 'DEVICE_INTERACTION_FALL_DETECTED',
    DeviceInteractionStandingDetected: 'DEVICE_INTERACTION_STANDING_DETECTED',
    DeviceInteractionEdgeOfBedDetected: 'DEVICE_INTERACTION_EDGE_OF_BED_DETECTED',
    ManualEntry: 'MANUAL_ENTRY',
    Claim: 'CLAIM',
    CareConfirmed: 'CARE_CONFIRMED',
    CareConfirmationFailed: 'CARE_CONFIRMATION_FAILED',
    M3BathAlertTriggered: 'M3_BATH_ALERT_TRIGGERED',
    M3BathAlertCanceled: 'M3_BATH_ALERT_CANCELED',
    M3AlertTriggered: 'M3_ALERT_TRIGGERED',
    M3AlertCanceled: 'M3_ALERT_CANCELED',
};
